import uuidv4 from "uuid/v4";

let todos = [];

// Fetch existing todos from localStorage
const loadTodos = () => {
  const todosJSON = localStorage.getItem("todos");
  try {
    todos = todosJSON ? JSON.parse(todosJSON) : [];
  } catch (e) {
    todos = [];
  }
};

// Save todos to localStorage
const saveTodos = () => {
  localStorage.setItem("todos", JSON.stringify(todos));
};

const getTodos = () => todos;

const createTodo = text => {
  todos.push({
    id: uuidv4(),
    text,
    completed: false
  });
  saveTodos(todos);
};

// Remove a todo by targeting UUID
const removeTodo = id => {
  const getToDoIndex = todos.findIndex(todo => todo.id === id);

  if (getToDoIndex > -1) {
    todos.splice(getToDoIndex, 1);
    saveTodos();
  }
};

// Toggle the checkbox and change the object's property
const toggleTodo = id => {
  const getToDo = todos.find(todo => todo.id === id);

  if (getToDo) {
    getToDo.completed = !getToDo.completed;
    saveTodos();
  }
};

// To populate todos array
loadTodos();

export { getTodos, createTodo, removeTodo, toggleTodo, loadTodos };
